import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_tableComponent = _resolveComponent("tableComponent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "回单申请超时列表",
    width: "880px",
    "custom-class": "bill-reapply-dialog",
    "close-on-click-modal": false,
    onOpen: _ctx.handleOpen
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.submitting,
          disabled: !_ctx.selectedIds.length,
          onClick: _ctx.handleConfirm
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" 再次申请 ")
          ])),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_tableComponent, {
        ref: "table",
        "table-data": _ctx.tableData,
        "table-head": _ctx.tableHead,
        "page-info": _ctx.pageInfo,
        "row-key": "id",
        "max-height": 500,
        description: "暂无回单申请超时记录",
        onSelectionChange: _ctx.handleSelectionChange,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange
      }, {
        idCardNo: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_ctx.maskIdCard(scope.row.idCardNo)), 1)
        ]),
        paymentAmount: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_ctx.formatAmount(scope.row.paymentAmount)), 1)
        ]),
        projectName: _withCtx((scope) => [
          _createVNode(_component_el_tooltip, {
            content: scope.row.projectName,
            disabled: _ctx.getTextLength(scope.row.projectName) <= 10,
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.truncateProjectName(scope.row.projectName)), 1)
            ]),
            _: 2
          }, 1032, ["content", "disabled"])
        ]),
        _: 1
      }, 8, ["table-data", "table-head", "page-info", "onSelectionChange", "onSizeChange", "onCurrentChange"])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen"]))
}